import React, { ReactNode } from 'react'

const Item = (props: { href?: string; children: ReactNode }) => {
  const { href, children } = props
  return (
    <li>
      {href ? (
        <a href={href} target='_blank' rel='noreferrer'>
          {children}
        </a>
      ) : (
        children
      )}
    </li>
  )
}

export default Item
